// extracted by mini-css-extract-plugin
export default {"root":"footer-wide_root__WY0Ox","icons":"footer-wide_icons__hS-cU","imageContainer":"footer-wide_imageContainer__sFG3s","image":"footer-wide_image__c2yqw"};